import React, { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { FaTimesCircle } from "react-icons/fa"

import classes from "./KpFail.module.scss"

const KpFail = () => {
  const [t] = useTranslation()

  const timeout = useRef()

  const history = useHistory()

  const handleGo = () => {
    clearTimeout(timeout.current)

    history.push("/kiosk-checkout")
  }

  useEffect(() => {
    timeout.current =
      setTimeout(() => handleGo(), 3000)

    return () => { clearTimeout(timeout.current) }
  }, [])

  return (
    <div
      onClick={handleGo}
      className={classes["container"]}
    >
      <FaTimesCircle color="white" size={150} />

      <h1 className={classes["title"]}>
        {t("سفارش شما پرداخت نشد لطفا مجددا تلاش کنید")}.
      </h1>
    </div>
  )
}

export default KpFail